import { useState } from 'preact/hooks';
export function useTableSort(defaultKey, defaultDirection = 'asc') {
    const [sortConfig, setSortConfig] = useState(defaultKey ? { key: defaultKey, direction: defaultDirection } : null);
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig && sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                direction = 'desc';
            }
            else if (sortConfig.direction === 'desc') {
                direction = null;
            }
        }
        setSortConfig(direction ? { key, direction } : null);
    };
    const getSortIndicator = (key) => {
        if (!sortConfig || sortConfig.key !== key) {
            return null;
        }
        return sortConfig.direction;
    };
    return { sortConfig, requestSort, getSortIndicator };
}
export function sortData(data, sortConfig, getComparator) {
    if (!sortConfig || !sortConfig.direction) {
        return data;
    }
    const comparator = getComparator(sortConfig.key);
    const sorted = [...data].sort(comparator);
    if (sortConfig.direction === 'desc') {
        return sorted.reverse();
    }
    return sorted;
}
